import React, { useEffect, useRef, useState } from 'react';
import {  Divider, Table, Popconfirm, Card, Tooltip, Switch,Input,Button,Tag,Row, Col, Drawer } from 'antd';
import {CountryDto, MasterBrandDto} from '@gtpl/shared-models/masters';
import {MasterBrandService} from '@gtpl/shared-services/masters';
import {CheckCircleOutlined,CloseCircleOutlined,RightSquareOutlined,EyeOutlined,EditOutlined,SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import {MasterBrandsForm, MasterBrandsFormProps} from '@gtpl/pages/master/master-components/master-brands-form';
import { Link, Redirect } from 'react-router-dom';

import './master-brands-grid.css';
import { EmployeeRolesEnum, UserRequestDto } from '@gtpl/shared-models/common-models';

/* eslint-disable-next-line */
export interface MasterBrandsGridProps {}

export function MasterBrandsGrid(
  props: MasterBrandsGridProps,
 
) {
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [masterBrandData, setMasterBrandData] = useState<MasterBrandDto[]>([]);
  const [selectedMasterBrandData, setSelectedMasterBrandData] = useState<any>(undefined);
  const [onUpdate,setOnUpdate] = useState(1)
  const masterBrandService=new MasterBrandService;
  const username = localStorage.getItem('username')

  useEffect(() => {
    getAllMasterBrands();
    
  }, [onUpdate]);

  /**
   * 
   */
 
  const getAllMasterBrands= () => {
    masterBrandService.getAllMasterBrands(new UserRequestDto(JSON.parse(localStorage.getItem('username')))).then(res => {
      if (res.status) {
        setMasterBrandData(res.data);
      } else {
        if (res.intlCode) {
          setMasterBrandData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setMasterBrandData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  
  const deleteBrand = (brandData:MasterBrandDto ) => {
    brandData.isActive = brandData.isActive?false:true;
    masterBrandService.activateOrDeactivateMasterBrand(brandData).then(res => { console.log(res);
      if(res.status){
        getAllMasterBrands();
        AlertMessages.getSuccessMessage(res.internalMessage);
      } else {
        if(res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const updateBrand = (brancData: MasterBrandDto) => {
    brancData.updatedUser= JSON.parse(localStorage.getItem('username'))
    masterBrandService.updateMasterBrand(brancData).then(res => { console.log(res);
      if (res.status) {
        AlertMessages.getSuccessMessage('Updated Successfully');
        setOnUpdate(prevState => prevState + 1)
        getAllMasterBrands();
        setDrawerVisible(false);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
   /**
   * used for column filter
   * @param dataIndex column data index
   */
  const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

    //drawer related
    const closeDrawer=()=>{
      setDrawerVisible(false);
    }
  
    //TO open the form for updation
    const openFormWithData=(viewData: MasterBrandDto)=>{
      setDrawerVisible(true);
     
      setSelectedMasterBrandData(viewData);
     console.log(selectedMasterBrandData);
    }


  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    
    {
      title: 'Brand Name',
      dataIndex: 'masterBrandName',
      // responsive: ['lg'],
      sorter: (a, b) => a.masterBrandName.localeCompare(b.masterBrandName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('masterBrandName')
    },
    {
      title: 'Display Brand Name',
      dataIndex: 'displayBrandName',
      // responsive: ['lg'],
      sorter: (a, b) => a.displayBrandName.localeCompare(b.displayBrandName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('displayBrandName')
    },
    // {
    //   title: 'Trim Name',
    //   dataIndex: 'trimName',
    //   // responsive: ['lg'],
    //   sorter: (a, b) => a.trimName.localeCompare(b.trimName),
    //   sortDirections: ['descend', 'ascend'],
    //   ...getColumnSearchProps('trimName')
    // },
    {
      title: 'Status',
      dataIndex: 'isActive',
      render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
          
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.isActive === value;
      },
      
    },
    {
      
      title:`Action`,
      dataIndex: 'action',
      render: (text, rowData) => (
        <span>      
          { username == '"ramakrishna"'?
            <>
            <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                  openFormWithData(rowData);
                } else {
                  AlertMessages.getErrorMessage('You Cannot Edit Deactivated Brand');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          
          <Divider type="vertical" />
            </>:''
          }   
            <Popconfirm onConfirm={e =>{deleteBrand(rowData);}}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate Brand ?'
                :  'Are you sure to Activate Brand ?'
            }
          >
            <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
            
          </Popconfirm>
        </span>
      )
    }
    
    
  ];

  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  const OpenFormTocreateRecord = () => {
   console.log('redirect here');
  }
  return (
    <Card title={<span style={{color:'white'}}>Brands</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/master-brands-form' >{(JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.SUPER_ADMIN)?'':<Button className='panel_button' >Create </Button>}</Link>}
    
    >
     <br></br>
     <Row gutter={40} >
      <Col>
          <Card title={'Total Brands: ' + masterBrandData.length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
           <Card title={'Active: ' + masterBrandData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active: ' + masterBrandData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col>
          </Row>
          <br></br>
          <Table
          rowKey={record => record.masterBrandId}
          columns={columnsSkelton}
          dataSource={masterBrandData}
          scroll = {{x:true}}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered />
         <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <MasterBrandsForm key={Date.now()}
                updateMasterBrand={ updateBrand }
                isUpdate={true}
                masterBrandData={selectedMasterBrandData}
                closeForm={closeDrawer} />
            </Card>
          </Drawer>
     </Card>
  );
}

export default MasterBrandsGrid;
